export enum SalesChannelType {
  DIRECT = "direct",
  INDIRECT = "indirect",
}
